<div class="cart-toast" *ngIf="event"
  [class.cart-toast--error]="event.tone === 'error'"
  [class.cart-toast--info]="event.tone === 'info'">
  <span class="cart-toast__icon" aria-hidden="true">{{ event.tone === 'error' ? '!' : (event.tone === 'info' ? 'i' : '✓') }}</span>
  <div class="cart-toast__content">
    <strong class="cart-toast__title">
      <ng-container *ngIf="event.title; else cartToastDefaultTitle">{{ event.title }}</ng-container>
      <ng-template #cartToastDefaultTitle>
        <ng-container *ngIf="event.tone === 'error'; else cartToastNonErrorTitle">{{ 'toast.notice' | t }}</ng-container>
        <ng-template #cartToastNonErrorTitle>
          <ng-container *ngIf="event.tone === 'info'; else cartToastSuccessTitle">{{ 'toast.notice' | t }}</ng-container>
          <ng-template #cartToastSuccessTitle>{{ 'toast.cart_updated' | t }}</ng-template>
        </ng-template>
      </ng-template>
    </strong>
    <span class="cart-toast__message">{{ event.message }}</span>
  </div>
  <span class="cart-toast__bar" aria-hidden="true"></span>
</div>

